
import { reactive, watch, onBeforeMount, onMounted, onUnmounted, computed } from 'vue';
import Button from '@/components/ui/button/index.vue';
import CardInfo from '@/components/ui/cardinfo/index.vue';
import ContentGroup from '@/components/ui/contentgroup/index.vue';
import Table from '@/components/ui/tablebox/index.vue';
import Tab from '@/components/ui/tab/index.vue';
import TableInfo from '@/components/ui/tableinfo/index.vue';
import Select from '@/components/ui/select/index.vue';
import CTmenu from '@/components/ui/ctmenu/index.vue';
import Pagination from '@/components/ui/pagination/index.vue';
import Switcher from '@/components/ui/switcher/index.vue';
import { CONNECTION, ACTIONBAR, POPUP, REPEAT_TYPE, USERMODE, FEATURENAME, BTN, BRIGHTNESSUNIT, BRIGHTNESSMAX, UNIT } from '@/enum/enum';
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex';
import { apiGroupDeviceList, apiGroupExecutedData, apiGroupSetting, apiGroupAppointment, apiSettings, apiETTasksList, apiDeleteGroupDevice, apiDeleteGroup, apiGroupNameModify, apiGetDevice, apiGetGroupModel, apiAddDevice, apiDeleteTask, apiDeleteAppointment } from '@/api/api';
import { dateTimeHandle } from '@/utils/time';
import { useI18n } from 'vue-i18n';
import { colorGamutHandler, gamutCustomHandler } from '@/utils/attribute';


// import * as moment from 'moment';


export default {
  name: 'groupdetail',
  components: {
    Button,
    CardInfo,
    ContentGroup,
    Tab,
    Select,
    Table,
    TableInfo,
    CTmenu,
    Pagination,
    Switcher
  },
  setup() {

    const { t } = useI18n();
    const route = useRouter()
    const routeStatic = useRoute();
    const brand = computed(() => storeState.brand)
    const state = reactive({
      rawData: {},
      settingIcon: [
        {
          key: 'calibration',
          status: true,
          text: '__d4e_m8t.__setACalibrationOrAppointmentTask',
        },
        {
          key: 'application',
          status: true,
          text: '__d7d_n17r.__osdProfileSettings',
        }
      ],
      iconStatus: {
        // asus_proart_sw_ico_lock:
      },
      meta: {
        total_page: 1,
        current: 1,
        per_page: 12,
      },
      columns: [
        {
          title: "Brightness",
          key: "brightness",
        },
        {
          title: "Color Temperature",
          key: "colorTemperature"
        },
        {
          title: "Gamma",
          key: "gamma",
        }
      ],
      isTabShow: route.currentRoute.value.params.tabId,
      modelOption: [],
      opDL: [
        {
          text: t('__common.__all'),
          val: '',
          isI18n: '__common.__all',
        },
        {
          text: t('__d7d_n17r.__connectionStatus'),
          val: 'connection',
          isI18n: '__d7d_n17r.__connectionStatus',
          sub: [
            {
              text: t('__g3p_m8t.__online'),
              val: '1',
              isI18n: '__g3p_m8t.__online',
            },
            {
              text: t('__g3p_m8t.__offline'),
              val: '0',
              isI18n: '__g3p_m8t.__offline',
            }
          ]
        },
      ],
      opET: [
        {
          text: t('__d4e_m8t.__allTasks'),
          val: '',
          isI18n: '__d4e_m8t.__allTasks',
        },
      ],
      opAP: [
        {
          text: t('__d4e_m8t.__allAppointments'),
          val: '',
          isI18n: '__d4e_m8t.__allAppointments',
        },
      ],
      selectVal1: {
        text: '請選擇',
        val: 'default',
      },

      deviceListData: [],
      appListData: [],
      appList2col: [
        {
          title: "Calibrator Type",
          key: "calibrator"
        },
        {
          title: "Gamuts",
          key: "gamuts",
        },
        {
          title: "Dynamic Range",
          key: "color_range"
        },
        {
          title: "Brightness",
          key: "brightness",
        },
        {
          title: "Color Temperature",
          key: "color_temperature"
        },
        {
          title: "EOTF",
          key: "eotf",
        },


      ],

      exeListData: [],

      modalList: [],

      modalList2: [],
      order: 'desc',
      sort: '',
      preset: [], //appointment mapping，預設值列表
      calibrators: [], //Calibrator Type
      colorRange: [], //setting傳回來的資料
      eotf: [], // eotf列表
      gamut: [], // gamut列表
      list: [],//打勾的列表
      applyDisable: true,
      modelList: [], //mapping list
      tableDisableList: [],
      modelName: '',
      compareList: [],//add device 的compare list
      defaultCheckIndexList: [], // default check index
    })


    // const fatherLink = route.currentRoute.value.fullPath
    // console.log(route.currentRoute.value.params.tabId,'params routeeeeeee')
    let interval = null;

    onMounted(() => {
      interval = setInterval(() => {
        let temp = routeStatic.path.split('/');
        let pathName = routeStatic.path.split('/')[temp.length - 1];
        if (pathName === ACTIONBAR.VIEWAPP || pathName === ACTIONBAR.VIEWHIS) {
          apiPost(false);
        }
      }, storeState.updateTime);

    }) //end: onMounted

    onUnmounted(() => {
      console.log('onUnmounted');
      clearInterval(interval);
    })


    watch(
      () => state.settingIcon,
      (val) => {
        if (val) {
          state.applyDisable = false
        }

      },
      { deep: true }
    )

    watch(
      () => route,
      (to) => {
        let a = to.currentRoute.value.params.tabId
        state.isTabShow = `${a}`;
        pageSettingInit()
        apiPost()

      },
      { deep: true }
    )

    watch(
      () => state.list,
      (val) => {
        if (val.length > 0) {
          state.defaultCheckIndexList = [];
          val.forEach(itm => {
            state.defaultCheckIndexList.push(itm.tableId);
          })
        }// end: if 
      }// end: val
    ) //end: watch 

    onBeforeMount(async () => {

      let a = route.currentRoute.value.params.tabId
      state.isTabShow = `${a}`;

      await pageSettingInit()
      await queryModels();
      await apiPost();
      // await getSetting();


    })

    const deviceListCol = computed(() => {
      return [
        {
          title: t('__g3p_m8t.__serialNumber'),
          key: "ssn",
          sort: true,
          // isLink: true,
        },
        {
          title: t('__d7d_n17r.__pcName'),
          key: "host",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__connectionStatus'),
          key: "status",
          color: true,  // 是否有客製化顏色，有的話直接讀取data值作為class名稱
          colorEnum:
          {
            0: CONNECTION[0],
            1: CONNECTION[1],
            2: CONNECTION[2],
          },
          isI18n:
          {
            0: '__g3p_m8t.__offline',
            1: '__g3p_m8t.__online',
            2: '__g3p_m8t.__waiting',
          },
          sort: true,
        },
        {
          title: t('__d7d_n17r.__ipAddress'),
          key: "ip",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__lastCalibrationDate'),
          key: "calibration",
          sort: true,
        },
        {
          title: t('__g3p_m8t.__executedTaskAmount', { num: '50' }),
          key: "task_executed_count",
          sort: true,
          color: true,
          colorRange:
          {
            0: 'general',
            44: 'caution',
            49: 'limit',
          },
        },
        {
          title: `${t('__d7d_n17r.__appointmentAmount')} (80)`,
          key: "appointment_count",
          sort: true,
          color: true,
          colorRange:
          {
            0: 'general',
            74: 'caution',
            79: 'limit',
          },
        },
      ]
    })


    const exeListCol = computed(() => {
      return [
        {
          title: t('__d4e_m8t.__implementDate'),
          key: "action_timestamp",
          sort: true,
        },
        {
          title: t('__common.__mode'),
          customRender: "modeColData",
          key: "mode2",
          sort: true,
        },
        {
          title: t('__g3p_m8t.__dynamicRange'),
          key: "color_range",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__profileName'),
          key: "profile_name",
          clickPopUp: 'profile_name_detail', //可以點擊出現選單，參數請設定需要被綁進Popup的key值
          clickPopUpIcon: 'asus_proart_sw_ico_arrow_s3', //此為default
          sort: true,
        },
        {
          title: t('__g3p_m8t.__implementationStatusSuccessFailWaitingForApply'),
          key: "implementationStatus",
          width: '30%',
          isLink: true,
        },

        {
          title: t('__d4e_m8t.__report'),
          customRender: "report", //客製化slot，可用於外接其他組件
          key: "report",
        },
      ]
    })


    const modalColumn = computed(() => {
      return [
        {
          title: t('__g3p_m8t.__serialNumber'),
          key: "ssn",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__pcName'),
          key: "host",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__connectionStatus'),
          key: "status",
          color: true,  // 是否有客製化顏色，有的話直接讀取data值作為class名稱
          colorEnum:
          {
            0: CONNECTION[0],
            1: CONNECTION[1],
            2: CONNECTION[2],
          },
          isI18n:
          {
            0: '__g3p_m8t.__offline',
            1: '__g3p_m8t.__online',
            2: '__g3p_m8t.__waiting',
          },
          sort: true,
        },
        {
          title: t('__d7d_n17r.__ipAddress'),
          key: "ip",
          sort: true,
        },

        // {
        //   title: "Connection Status", 
        //   key: "connectionStatus", 
        //   color: true,
        // },
        // {
        //   title: "Implementation status", 
        //   key: "Implementation status", 
        //   color: true,
        // },
        // {
        //   title: "Report", 
        //   key: "report", 
        //   customRender: "report",
        // },
      ]
    })


    const modalColumn2 = computed(() => {//depiction_code
      // let
      return [
        {
          title: t('__g3p_m8t.__serialNumber'),
          key: "ssn",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__pcName'),
          key: "host",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__connectionStatus'),
          key: "device_status",
          color: true,
          colorEnum:
          {
            0: CONNECTION[0],
            1: CONNECTION[1],
            2: CONNECTION[2],
          },
          isI18n:
          {
            0: '__g3p_m8t.__offline',
            1: '__g3p_m8t.__online',
            2: '__g3p_m8t.__waiting',
          },
          sort: true,
        },
        {
          title: t('__d4e_m8t.__implementationStatus'),
          key: "newStatus",
          color: true,
          colorEnum: //顏色設定
          {
            999: CONNECTION[0],
            1: CONNECTION[1],
            2: CONNECTION[2],
            4: CONNECTION[1],
          },
          isI18n:
          {
            999: '__common.__fail',
            1: '__common.__success',
            2: '__d7d_n17r.__waitingForReply',
            4: '__common.__successDeleted',
          },
          sort: true,
        },
        {
          title: t('__d4e_m8t.__report'),
          key: "report",
          customRender: "report",
        }
      ]
    })
    const customXD = computed(() => {
      return '12233'
    })


    const appListCol = computed(() => {
      return [
        {
          title: t('__d4e_m8t.__setDate'),
          key: "updated_at",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__repeat'),
          key: "repeatCol",
          customRender: "repeatColData",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__upcomingCalibrationDate'),
          key: "next_timestamp",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__time'),
          key: "time",
          sort: true,
        },
        {
          title: t('__common.__modify'),
          customRender: "modify", //客製化slot，可用於外接其他組件
          key: "modify",
        },
      ]
    })


    const tabText = computed(() => {
      return [{
        name: t('__g3p_m8t.__deviceList'),
        val: ACTIONBAR.DEVICELIST,
        disabled: false,
      }, {
        name: t('__d4e_m8t.__executedTasks'),
        val: ACTIONBAR.VIEWHIS,
        disabled: false,
      }, {
        name: t('__g3p_m8t.__appointment'),
        val: ACTIONBAR.VIEWAPP,
        disabled: false,
      }, {
        name: t('__d4e_m8t.__settings'),
        val: ACTIONBAR.SETTING,
        disabled: false,
      }]

    })

    const appListColSub = computed(() => {
      return {
        calibrator: t('__d4e_m8t.__calibratorType'),
        presetMode: t('__d4e_m8t.__presetMode', { brand: brand.value }),
        gamut: t('__c3d_t4t.__colorGamut'),
        color_range: t('__g3p_m8t.__dynamicRange'),
        brightness: t('__d4e_m8t.__brightness'),
        gamma: t('__c3d_t4t.__gamma'),
        color_temperature: t('__d4e_m8t.__colorTemperature'),
        coordinate: t('__d4e_m8t.__coordinate'),
        eotf: t('__d4e_m8t.__eotf'),
      }
    })



    const pageSettingInit = () => {
      state.meta.current = 0;
      state.meta.total_page = 1;
      state.meta.per_page = 12;
      switch (state.isTabShow) {
        case ACTIONBAR.VIEWAPP:
          state.selectVal1 = state.opAP[0]
          break;
        case ACTIONBAR.VIEWHIS:
          state.selectVal1 = state.opET[0]
          break;
        case ACTIONBAR.DEVICELIST:
          state.selectVal1 = state.opDL[0]
          break;
      }
    }


    const queryModels = async () => {
      try {
        const datas = await apiGetGroupModel();
        if (!datas.status_code) {
          state.modelList = datas.model
          let arr = [];
          for (let j = 0; j < state.modelList.length; j++) {
            arr.push({ text: state.modelList[j], val: state.modelList[j] })
            state.modelOption = arr
          }
        }
      }
      catch (error) {
        return error;
      }
    }

    const apiPost = (isNeedLoading = true) => {
      switch (state.isTabShow) {
        case ACTIONBAR.SETTING:
        case ACTIONBAR.DEVICELIST:
          getDLData(isNeedLoading);  //tbd
          break;
        case ACTIONBAR.VIEWAPP:
          getAPData(isNeedLoading)
          break;
        case ACTIONBAR.VIEWHIS:
          getETData(isNeedLoading);
          break;


        default: ACTIONBAR.DEVICELIST
          break;
      }
    }


    const getDLData = async (isNeedLoading = true) => {
      store.commit('setIsNeedLoading', isNeedLoading);
      const id = route.currentRoute.value.params.name;
      const sendData = {
        page: state.meta.current,
        order: state.order,
        sort: state.sort ? state.sort : 'bound_at',
        status: state.selectVal1['val'],
      }
      try {
        const datas = await apiGroupDeviceList(id, sendData);
        console.log('apiGroupDeviceList', datas)
        if (!datas.status_code) {
          state.modelName = datas.model;
          // await getSetting();
          datas.created_at = dateTimeHandle(datas.created_at);
          for (let i = 0; i < datas.data.length; i++) {
            if (datas.data[i].calibration) {

              datas.data[i].calibration = dateTimeHandle(datas.data[i].calibration);
            } else {
              datas.data[i].calibration = ''
            }
          }
          datas.connectionsStatus = {
            'device_online_count': datas.device_online_count,
            'device_offline_count': datas.device_offline_count,
          }
          datas.imgUrl = datas.last_page_url;
          state.deviceListData = datas.data;
          state.meta.current = datas.current_page;
          state.meta.total_page = datas.last_page;
          state.meta.per_page = datas.per_page;
          state.settingIcon[0].status = !datas.lock_task; //tbd
          state.settingIcon[1].status = !datas.lock_osd;  //tbd
          console.log(state.settingIcon, 'ioioi')
          state.rawData = datas;
        }
      }
      catch (error) {
        return error;
      }
    }

    const getETData = async (isNeedLoading = true) => {
      store.commit('setIsNeedLoading', isNeedLoading);
      const id = route.currentRoute.value.params.name
      // console.log(route.currentRoute.value)
      const sendData = {
        page: state.meta.current,
        order: state.order,
        sort: state.sort ? state.sort : 'action_timestamp',
      }
      try {
        const datas = await apiGroupExecutedData(id, sendData);
        console.log('apiGroupExecutedData', datas)
        if (!datas.status_code) {
          if (datas.model) {
            state.modelName = datas.model;
            await getSetting();
          }

          datas.created_at = dateTimeHandle(datas.created_at);
          for (let i = 0; i < datas.data.length; i++) {
            datas.data[i].action_timestamp = dateTimeHandle(datas.data[i].action_timestamp);
            if (datas.data[i].color_range != undefined && state.colorRange && typeof state.colorRange === 'object') {
              datas.data[i].color_range = Object.keys(state.colorRange).find(key => state.colorRange[key] === datas.data[i].color_range);  //Dynamic Range	的 enum 從apiSetting來的
            }
            datas.data[i].implementationStatus = `${datas.data[i].success}/${datas.data[i].fail}/${datas.data[i].wait}`;
            datas.data[i].mode2 = datas.data[i].mode;
            console.log(datas.data[i].mode2, 'mode2')
            datas.data[i].mode = USERMODE[datas.data[i].mode]
          }
          datas.imgUrl = datas.last_page_url;
          datas.connectionsStatus = {
            'device_online_count': datas.device_online_count,
            'device_offline_count': datas.device_offline_count,
          }
          state.exeListData = datas.data;
          state.meta.current = datas.current_page;
          state.meta.total_page = datas.last_page;
          state.meta.per_page = datas.per_page;
          state.rawData = datas;
          state.tableDisableList = state.exeListData.map((e) => {
            return e.wait > 0
          })
        }
      }
      catch (error) {
        return error;
      }
    }


    const getAPData = async (isNeedLoading = true) => {
      store.commit('setIsNeedLoading', isNeedLoading);
      const id = route.currentRoute.value.params.name
      console.log(route.currentRoute.value)
      const sendData = {
        page: state.meta.current,
        order: state.order,
        sort: state.sort ? state.sort == "repeat_type" ? "repeat" : state.sort : 'updated_at',
      }
      try {
        const datas = await apiGroupAppointment(id, sendData);
        console.log('apiGroupAppointment', datas)
        if (!datas.status_code) {
          if (datas.model) {
            state.modelName = datas.model;
            await getSetting();
          }

          datas.created_at = dateTimeHandle(datas.created_at);
          datas.imgUrl = datas.last_page_url;

          for (let i = 0; i < datas.data.length; i++) {
            if (datas.data[i].updated_at) {
              datas.data[i].updated_at = dateTimeHandle(datas.data[i].updated_at, 'x');
            }
            datas.data[i].repeat_start_date = dateTimeHandle(datas.data[i].repeat_start_date, 'YYYY.MM.DD');
            if (datas.data[i].next_timestamp) {
              datas.data[i].next_timestamp = dateTimeHandle(datas.data[i].next_timestamp, 'x');
            } else {
              datas.data[i].next_timestamp = null;
            }

            datas.data[i].time_zone = datas.data[i].time_zone > 0 ? `+${datas.data[i].time_zone}` : datas.data[i].time_zone;
            if (datas.data[i].repeat_start_min || datas.data[i].repeat_start_min == 0) { //給的分鐘數沒有補0，自己補一下
              if (datas.data[i].repeat_start_min.toString().length < 2) {
                datas.data[i].repeat_start_min = `0${datas.data[i].repeat_start_min}`
                // console.log(datas.data[i].repeat_start_min)
              }
            }
            datas.data[i].time = `${datas.data[i].repeat_start_hour}:${datas.data[i].repeat_start_min} (UTC${datas.data[i].time_zone})`;
            let hasTarget = datas.data[i].preset_target ? Array.isArray(datas.data[i].preset_target) ? datas.data[i].preset_target.length : true : false;
            console.log('hasTarget', hasTarget)
            if (hasTarget) {
              datas.data[i].secondTitle = 'Calibrator'
              datas.data[i].dataInfo = []
              datas.data[i].dataInfo = presetTarget(datas.data[i].preset_target, datas.data[i].calibrator)
              console.log(datas.data[i].dataInfo)
            } else {
              // console.log(i,'index')
              datas.data[i].dataInfo = []
              let col = []
              let data = []
              let obj = { calibrator: state.calibrators[datas.data[i].calibrator], ...(datas.data[i].custom_settings || {}) }
              // console.log('datas.data[i].custom_settings',datas.data[i].custom_settings)
              if (obj['eotf'] && obj['eotf'] == 2) {  //當eotf數值為2的時候會有brightness_min，兩個都要放進brightness裡面 //0421改
                // obj['brightness'] = obj['brightness_min']
                if (obj['brightness']) {
                  let brightness;
                  if (datas.data[i].calibrator == 4 && (obj['brightness'] > 650)) {
                    brightness = isSpecificCalibrator(obj['brightness'])//特殊規格矯正器限制，最高只能固定650，但給user設定的數字要標註在後面
                  } else {
                    for (const key in BRIGHTNESSMAX) {
                      if (obj['brightness'] == key) {
                        brightness = BRIGHTNESSMAX[key]
                      } else {
                        brightness = ` ${obj['brightness']} ${UNIT.NTM2}`;
                      }
                    }
                  }
                  obj['brightness'] = `${BRIGHTNESSUNIT.lmax} :  ${brightness} <br> ${BRIGHTNESSUNIT.lmin}  : ${obj['brightness_min']} ${UNIT.NTM2}`
                } else {
                  obj['brightness'] = `${BRIGHTNESSUNIT.lmin} : ${obj['brightness_min']} ${UNIT.NTM2}`
                }
              } else {
                if (obj['brightness']) {
                  let brightness;
                  if (datas.data[i].calibrator == 4 && (obj['brightness'] > 650)) {
                    brightness = isSpecificCalibrator(obj['brightness'])//特殊規格矯正器限制，最高只能固定650，但給user設定的數字要標註在後面
                  } else {
                    for (const key in BRIGHTNESSMAX) {
                      if (obj['brightness'] == key) {
                        brightness = BRIGHTNESSMAX[key]
                      } else {
                        brightness = ` ${obj['brightness']} ${UNIT.NTM2}`;
                      }
                    }
                  }
                  obj['brightness'] = ` ${brightness}`;
                  // obj['brightness'] = ` ${obj['brightness']} ${UNIT.NTM2}`;
                }
              }

              if (obj['color_temperature'] || obj['color_temperature'] == 0) {
                obj['color_temperature'] = obj['color_temperature'] + 'k'
              }

              //coordinate start
              if (obj['color_x'] && obj['color_y']) {
                obj['coordinate'] = `x : ${obj['color_x']}   y : ${obj['color_y']}`
              }
              //coordinate end

              if (obj['color_range'] || obj['color_range'] == 0) {  //mapping apiSetting 的 color_range
                if (state.colorRange && typeof state.colorRange === 'object') {
                  obj['color_range'] = Object.keys(state.colorRange).find(key => state.colorRange[key] === obj['color_range']);  //從value找 key 值......

                  if (obj['gamut'] || obj['gamut'] == 0) {
                    const originalGamutValue = obj['gamut']; // 保留原始值
                    for (const k in state.colorRange) {
                      if (obj['color_range'] == k && state.gamut && state.gamut[k]) {  //照color_range的不同，Gamut要mapping的obj不一樣
                        obj['gamut'] = Object.keys(state.gamut[k]).find(key =>   //state.gamut有兩個obj，先根據color_range的key值去找到哪一個obj，再從api 給的Gamut的value找 對應的key 值
                          state.gamut[k][key] == obj['gamut']
                        );
                      }
                    }
                    // 使用 colorGamutHandler 顯示 Gamut
                    if (originalGamutValue === 7 && obj['gamut_custom']) {
                      // Custom Gamut，使用 gamutCustomHandler 顯示
                      obj['gamut'] = gamutCustomHandler(obj['gamut_custom']);
                    } else {
                      obj['gamut'] = colorGamutHandler(originalGamutValue);
                    }
                  }
                  if (obj['eotf'] || obj['eotf'] == 0) {
                    if (obj['eotf'] && obj['eotf'] == 1) {  //當eotf數值為1 (Gamma)的時候，Gamma這個欄位要直接被消失，並把原本Gamma內的數值放進eotf中
                      obj['eotf'] = `Gamma ${obj['gamma']}`
                      // console.log(obj['eotf'],obj['gamma'], "obj['eotf']")
                      obj = Object.fromEntries(Object.entries(obj).filter(([key]) => {
                        return key != 'gamma'
                      }));
                    } else {
                      for (const k in state.colorRange) {
                        if (obj['color_range'] == k && state.eotf && state.eotf[k]) {  //照color_range的不同，eotf要mapping的obj不一樣
                          obj['eotf'] = Object.keys(state.eotf[k]).find(key =>   //state.eotf有兩個obj，先根據color_range的key值去找到哪一個obj，再從api 給的eotf的value找 對應的key 值
                            state.eotf[k][key] == obj['eotf']
                          );
                        }
                      }
                    }
                  }
                }

              }
              // console.log('UIU',obj)
              data.push(obj ? obj : ' ')
              let tempCol = Object.fromEntries(Object.entries(obj).filter(([_, v]) => { return _ && v != null })); //去除value為null 或空值的key
              // let tempCol = Object.fromEntries(Object.entries(obj).filter(() => { return true })); //不去除空直了
              col = Object
                .keys(tempCol)
                .filter(key => key && key != 'brightness_min' && key != 'gamma' && key != 'gamut_custom')  //brightness_min, gamma, gamut_custom 不呈現在 th 上面
                .map((e) => {
                  return {
                    'title': e, //原 PRESET_TITLE[e]
                    'key': e
                  }
                })
              datas.data[i].dataInfo.push({ data: data, col: col })
            }
          }
          datas.connectionsStatus = {
            'device_online_count': datas.device_online_count,
            'device_offline_count': datas.device_offline_count,
          }
          setRepeat(datas.data)

          state.meta.current = datas.current_page;
          state.meta.total_page = datas.last_page;
          state.meta.per_page = datas.per_page;
          state.rawData = datas;
          state.appListData = datas.data;


        }
      }
      catch (error) {
        return error;
      }
    }

    const isSpecificCalibrator = (val) => { //特殊規格矯正器限制，最高只能固定650，但給user設定的數字要標註在後面
      for (const key in BRIGHTNESSMAX) {
        if (val == key) {
          return `650 (${BRIGHTNESSMAX[key]}) ${UNIT.NTM2}`
        } else {
          return `650 (${val}) ${UNIT.NTM2}`
        }
      }
    }


    const presetTarget = (target, calibrator) => {
      // console.log('target, calibrator',target, calibrator,state.preset)
      let arr = []
      for (let k = 0; k < target.length; k++) {
        let col = []
        let data = []
        let presetData = state.preset && state.preset[target[k]] ? state.preset[target[k]] : {};
        let obj = { calibrator: state.calibrators[calibrator], ...presetData, presetMode: presetData.name }

        // 處理 Gamut 顯示
        if (obj['gamut'] || obj['gamut'] == 0) {
          const originalGamutValue = obj['gamut'];
          if (originalGamutValue === 7 && obj['gamut_custom']) {
            // Custom Gamut，使用 gamutCustomHandler 顯示
            obj['gamut'] = gamutCustomHandler(obj['gamut_custom']);
          } else {
            obj['gamut'] = colorGamutHandler(originalGamutValue);
          }
        }

        if (obj['color_range']) {
          if (obj['eotf']) {
            if (state.eotf && state.eotf[obj['color_range']]) {
              let temp = Object.keys(state.eotf[obj['color_range']]).find(key =>  //把Gamma找出來比對
                key == 'Gamma'
              );
              if (temp == obj['eotf']) {
                obj['eotf'] = `${obj['eotf']}  ${obj['gamma']}`
                obj = Object.fromEntries(Object.entries(obj).filter(([key]) => {
                  return key != 'gamma'
                }));
              }
            }
          }
        }
        if (obj['brightness']) {
          obj['brightness'] = `${obj['brightness']} ${UNIT.NTM2}`
        }

        data.push(obj ? obj : ' ')
        // let tempCol = Object.fromEntries(Object.entries(obj).filter(([_, v]) => { return _ && v != null })); //去除value為null 或空值的key
        let tempCol = Object.fromEntries(Object.entries(obj).filter(() => { return true }));//不去除空值了
        col = Object
          .keys(tempCol)
          .filter(key => key && key != 'name' && key != 'id' && key != 'color_range' && key != 'gamma' && key != 'gamut_custom')  //name, id, color_range, gamma, gamut_custom 不呈現在 th 上面
          .map((e) => {
            return {
              'title': e, //原 PRESET_TITLE[e]
              'key': e
            }
          })
        arr.push({ data: data, col: col })
      }
      return arr
    }

    const getSetting = async () => {
      console.log(state.rawData, 'state.rawData')
      const sendData = {
        model: state.modelName,
      }
      try {
        const datas = await apiSettings(sendData);
        console.log('apiSettings', datas)
        state.preset = datas.data.model.preset_modes;
        datas.data.calibrators.forEach((item) => {
          state.calibrators[item.id] = item.name
        })
        state.colorRange = datas.data.color_range
        state.eotf = datas.data.eotf
        state.gamut = datas.data.gamut
      }
      catch (error) {
        return error;
      }
    }

    const setAppListColSub = (e) => {
      let temp = []
      for (let key in appListColSub.value) {
        for (let i = 0; i < e.length; i++) {
          if (key == e[i].title) {
            temp.push({
              'title': appListColSub.value[key],
              'key': e[i].key
            })
          }
        }

      }
      return temp
    }

    const setRepeatCol = (e) => {
      if (e.repeat_cycle) {
        if (REPEAT_TYPE[e.repeat_type] == 'week') {
          return t('__d4e_m8t.__repeatEveryNumWeek', { num: `  ${e.repeat_cycle}` });
        } else {
          return t('__d4e_m8t.__repeatEveryNumMonth', { num: `  ${e.repeat_cycle}` });
        }
      } else {
        return 'Single'
      }
    }



    const modeCol = (data, col) => {
      if (data[col.key] == 1 || data[col.key] == 2 || data[col.key] == 3) {
        return t('__d4e_m8t.__userMode') + ' ' + data[col.key]
      } else if (data[col.key] == 0) {
        return t('__d4e_m8t.__presetMode', { brand: brand.value })
      } else {
        return '- - -'
      }
    }


    const geCVS = async () => {
      console.log(window.location.origin, `${window.location.origin}/api/v1/groups/${state.rawData['id']}/export-csv`)
      const env = process.env.NODE_ENV;
      let url = '';
      switch (env) {
        case 'mock':  // mock env
        case 'dev':  //localhost開發 port:8080 
          url = `https://proart-adc.azurewebsites.net/api/v1/groups/${state.rawData['id']}/export-csv`
          break;
        case 'dev-online': // 線上RD測試機
        case 'staging':
        case 'adc':
        case 'prod':
          url = `${window.location.origin}/api/v1/groups/${state.rawData['id']}/export-csv`
          break;
      }
      console.log('url', url)
      // const link = document.createElement('a');
      // link.href = url;
      // link.click();
    }


    const getTasks = async (v) => {
      const id = v.val.id
      const sendData = {
        // sort: 'fff',
        // order: 'ffff', //tbd 預設
      }
      try {
        const datas = await apiETTasksList(id, sendData);
        console.log('apiGetTasks', datas)
        state.modalList2 = datas.tasks;
        for (let i = 0; i < state.modalList2.length; i++) {
          state.modalList2[i].newStatus = null
          if (state.modalList2[i].deleted) {
            state.modalList2[i].newStatus = 4
          } else {

            if (state.modalList2[i].status == 0) {
              state.modalList2[i].newStatus = 999
            } else {
              state.modalList2[i].newStatus = state.modalList2[i].status
            }
          }
          console.log('ghtty', state.modalList2[i].status, state.modalList2[i].newStatus)
        }//depiction_code


        const modalConfig = {
          type: POPUP.IMPLEMENTATION,
          data: {
            col: modalColumn2,
            list: state.modalList2,
            id: v.val.id,
            optionModel: state.modelOption,
            optionStatus: state.opDL,
            group_name: state.rawData['name']
          },
          isShow: true,
        }
        store.commit('setIsShowModal', modalConfig)

      }
      catch (error) {
        return error;
      }

    }

    const deleteDevice = async () => {
      let groupId = state.rawData['id']
      let id = []
      id = state.list.map(item => item.id);
      console.log(id)
      const sendData = {
        id: id,
      }
      try {
        const datas = await apiDeleteGroupDevice(groupId, sendData);
        console.log('apiDeleteGroupDevice', datas)

        if (!datas.status_code) {

          apiPost()
          state.list.splice(0, state.list.length)
        }

      }
      catch (error) {
        return error;
      }
    }

    const deleteET = async () => {
      console.log(state.list)
      let id = []
      id = state.list.map(item => item.id);
      const sendData = {
        id: id,
        appointment: true,
      }
      try {
        const datas = await apiDeleteTask(sendData);
        console.log('apiDeleteTask', datas)
        if (!datas.status_code) {
          apiPost()
          state.list.splice(0, state.list.length)
        }
      }
      catch (error) {
        return error;
      }
    }

    const deleteAP = async () => {
      console.log(state.list)
      let id = []
      id = state.list.map(item => item.id);
      const sendData = {
        id: id,
      }
      try {
        const datas = await apiDeleteAppointment(sendData);
        console.log('apiDelete Appointment', datas)
        if (!datas.status_code) {
          apiPost()
          state.list.splice(0, state.list.length)
        }
      }
      catch (error) {
        return error;
      }
    }

    const deleteGroup = async (output) => {
      let tempArr = [];
      tempArr.push(state.rawData['id'])
      const sendData = {
        id: tempArr,
        unbind: output.action
      }
      try {
        await apiDeleteGroup(sendData);
        route.push(`/main/group`);
      }
      catch (error) {
        return error;
      }
    }


    const editGroupSetting = async () => {
      let groupId = state.rawData['id']
      const sendData = {
        lock_task: !state.settingIcon[0].status,
        lock_osd: !state.settingIcon[1].status,
      }
      try {
        const datas = await apiGroupSetting(groupId, sendData);
        console.log('apiDeleteGroupDevice', datas)
        store.commit('setFlashMsg', { data: `${state.rawData['model']} ${t('__flash.__permissionSettingsApplySuccessfully')}`, isShow: true })
        if (!datas.status_code) {
          apiPost()
        }

      }
      catch (error) {
        return error;
      }
    }



    const modalDeviceList = async () => {
      await getDLCompareList()
      let defaultModel = state.rawData['model'] ? state.rawData['model'] : ' ';
      let selectDisable = defaultModel == ' ' ? false : true;
      const maxNum = Number.MAX_SAFE_INTEGER;
      const sendData = {
        per_page: maxNum,
        model: defaultModel == ' ' ? undefined : defaultModel,
      }
      try {
        const datas = await apiGetDevice(sendData);
        console.log('apiGetDevice modal', defaultModel, datas.data)
        state.modalList = datas.data;


        state.modalList = state.modalList.filter((e) => {  //model 為null的話不顯示
          return e.model
        })
        state.modalList = state.modalList.filter((e) => {  //model 狀態為waiting的話不顯示
          return e.status != 2
        })

        state.modalList = state.modalList.filter((e) => {  //device已存在的話不顯示
          // console.log(e.id, state.compareList.indexOf(e.id) < 0)
          return state.compareList.indexOf(e.id) < 0
        });


        // console.log('這邊state.modalList',state.modalList)


        // console.log(defaultModel,'外面',state.modelOption)
        const modalConfig = {
          type: POPUP.DEVICEDETAIL,
          data: {
            selectDisable,  //下拉選單是否 disable
            defaultModel,  //有沒有預先選擇的model
            col: modalColumn,
            list: state.modalList,
            selectModel: state.modelOption,
            selectStatus: state.opDL,
            compareList: state.compareList
          },
          isShow: true,
        }

        // console.log('呱吉沒朋友',modalConfig)

        store.commit('setIsShowModal', modalConfig)
      }
      catch (error) {
        return error;
      }
    }


    const getDLCompareList = async () => {
      const id = route.currentRoute.value.params.name;
      const sendData = {
        page: 1,
        per_page: Number.MAX_SAFE_INTEGER
      }
      try {
        const { data } = await apiGroupDeviceList(id, sendData);
        // console.log('api Group Compare DeviceList', data)
        state.compareList = data.map((e) => {
          return e.id
        })
      }
      catch (error) {
        return error;
      }
    }


    //Add Device in the Group
    const addDevice = async (output) => {
      const groupId = state.rawData['id']
      let id = []
      id = output.map(item => item.id);
      const sendData = {
        id: id,
      }
      try {
        const datas = await apiAddDevice(groupId, sendData);
        console.log('apiDeleteGroupDevice', datas)
        if (!datas.status_code) {
          apiPost()
        }
      }
      catch (error) {
        if (error.response.data.status_code == 6) {

          // let devices = [  //local測試用
          //   "PA329AC_AA1500072-PC",
          //   "PA329AC_AA1500072-PC"
          // ]
          // console.log('?????',error.response.data.status_code)
          const modalConfig = {
            type: POPUP.OVERFLOW,
            data: {
              list: error.response.data.devices,//
            },
            isShow: true,
          }

          store.commit('setIsShowModal', modalConfig)
          // if()
        }

        return error;
      }
    }

    const setRepeat = (v) => {
      v.forEach(e => {
        if (e.repeat_cycle) {
          if (REPEAT_TYPE[e.repeat_type] == 'week') {

            e.repeatCol = t('__d4e_m8t.__repeatEveryNumWeek', { num: `  ${e.repeat_cycle}` });
          } else {
            e.repeatCol = t('__d4e_m8t.__repeatEveryNumMonth', { num: `  ${e.repeat_cycle}` });
          }
        } else {
          e.repeatCol = 'Single'
        }
      });

    }

    const onClickTab = (v) => {
      console.log(v)
      let fullPath = route.currentRoute.value.fullPath.split("/")
      let path = fullPath.filter((element, index) => index < fullPath.length - 1).join('/');
      route.push(`${path}/${v.item.val}`);
      route.push({
        path: `${path}/${v.item.val}`,
        query: {
          gName: route.currentRoute.value.query.gName,
        },
      });
      state.selectVal1 = {
        text: '請選擇',
        val: 'default',
      }

    }

    const downloadCVS = () => {
      // emit('setUnbind', dataInfo) tbd
    }

    const setCalibration = () => {
      let temp = []
      temp.push(state.rawData)
      let next = temp[0].data
      // console.log(temp[0].data)
      store.commit('setCalibrationList', { title: 'group', content: temp, next: next });
      console.log('temp', store.state.calibrationList)
      route.push({ name: FEATURENAME.CALIBRATIONDEFAULT });
    }

    const editApp = (e) => {
      const groupId = state.rawData['id']
      // console.log(i,e,'edit App')
      route.push(`/main/calibration/modify/group/${groupId}/${e.id}`);
    }


    const changePage = (page) => {
      state.meta.current = page;
      if (page != 1) {
        apiPost()
      }
    }
    const tableSort = (v) => {
      console.log(v, 'sort table')
      state.order = v.val === 'up' ? 'asc' : 'desc';
      state.sort = v.key;
      if (state.isTabShow == ACTIONBAR.VIEWAPP) {
        switch (v.key) {
          case 'repeatCol':
            state.sort = 'repeat_type'
            break;
        }
      }
      apiPost()
    }

    const onCheckAll = (v) => {
      console.log(v, 'table onCheck All')
      state.list = v
    }

    const onCheckEach = (v) => {
      // console.log(v,'table onCheck Each')
      state.list = v

    }

    const selectChange = (v) => {
      if (v) {
        state.meta.current = 1
        apiPost()
      }
    }

    const showCTAndRow = (v) => {
      console.log(v, 'show ??? ContextMenu')
    }

    const selectContextMenu = (v) => {
      console.log(v, 'show ContextMenu')
    }

    const applyCalibration = (data) => {
      console.log('applyToCalibration', data)
    }

    const settingLock = (e) => {
      e.status = !e.status
    }



    const store = useStore()
    const storeState = store.state;

    const littleMenuSetting = (v) => {
      let modalConfig = {}
      let localList = [];
      switch (v.key) {
        case 'addDevice':
          modalDeviceList()
          break;
        case 'renameGroupName':
          modalConfig = {
            type: POPUP.MODIFYGROUP,
            data: {
              groupName: state.rawData['name'],
            },
            isShow: true,
          }
          store.commit('setIsShowModal', modalConfig)
          break;
        case 'unGroupOnly':
          localList.push()
          modalConfig = {
            type: POPUP.UNGROUP,
            data: {
              list: state.list,
              action: false,
              groupID: state.rawData['id'],
            },
            isShow: true,
          }
          store.commit('setIsShowModal', modalConfig)
          break;
        case 'unGroupAndUnbindAll':

          modalConfig = {
            type: POPUP.UNBIND,
            data: {
              list: state.list,
              action: true,
              groupID: state.rawData['id'],
            },
            isShow: true,
          }
          store.commit('setIsShowModal', modalConfig)
          break;
      }

    }


    const groupNameModify = async (output) => {
      const groupId = state.rawData['id']
      const sendData = {
        name: output,
      }
      console.log(sendData)
      try {
        const datas = await apiGroupNameModify(groupId, sendData);
        console.log('apiGroupNameModify', datas)
        apiPost() //tbdddddd
      }
      catch (error) {
        return error;
      }
    }

    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.MODIFYGROUP) {
        console.log('storeState.modalBtnType', storeState.modalBtnType);
        // modal btn type 決定要幹嘛
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput
          groupNameModify(output)
        }
      } else if (oldType === POPUP.UNGROUP || oldType === POPUP.UNBIND) {
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput;
          // console.log(output,'output')
          deleteGroup(output)
        }
      } else if (oldType === POPUP.DEVICEDETAIL) {
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput;
          // addDevice(output) //等等刪
          let resultArr = output.map((e) => {
            return e.model
          })
          let arr = Array.from(new Set(resultArr))
          console.log('addDevice output', arr)
          if (arr.length > 1) {
            const modalConfig = {
              type: POPUP.DEVICEMODELERROR,
              data: {
              },
              isShow: true,
            }

            store.commit('setIsShowModal', modalConfig)
          } else {
            addDevice(output)
          }


        }
      } else if (oldType === POPUP.DEVICEMODELERROR) {
        // console.log('toreState.modalBtnType', storeState.modalBtnType);
        modalDeviceList()
      } else if (oldType === POPUP.OVERFLOW) {
        // console.log('toreState.modalBtnType', storeState.modalBtnType);
        modalDeviceList()
      }
    })









    const goDeviceLink = () => {

    }

    const goTableLink = (v) => {
      console.log(v, 'table link')
      getTasks(v)

    }



    return {
      state,
      onClickTab,
      downloadCVS,
      setCalibration,
      tableSort,
      onCheckAll,
      onCheckEach,
      goTableLink,
      showCTAndRow,
      selectContextMenu,
      applyCalibration,
      changePage,
      editApp,
      settingLock,
      littleMenuSetting,
      goDeviceLink,
      getETData,
      apiPost,
      getAPData,
      setRepeat,
      getSetting,
      presetTarget,
      getTasks,
      deleteDevice,
      deleteGroup,
      groupNameModify,
      modalDeviceList,
      queryModels,
      addDevice,
      selectChange,
      deleteET,
      deleteAP,
      geCVS,
      editGroupSetting,
      pageSettingInit,
      getDLCompareList,
      t,
      tabText,
      deviceListCol,
      appListCol,
      exeListCol,
      modalColumn,
      modalColumn2,
      appListColSub,
      setAppListColSub,
      customXD,
      isSpecificCalibrator,
      modeCol,
      setRepeatCol
    }
  }// end: setup

}


